import { Component, AfterViewInit, EventEmitter, OnInit, Output, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { element } from 'protractor';
import { HttpErrorResponse } from '@angular/common/http';
import { PaymentHistoryComponent } from '../payment-history/payment-history.component';
@Component({
  selector: 'app-fee-process',
  templateUrl: './fee-process.component.html',
  styleUrls: ['./fee-process.component.scss']
})
export class FeeProcessComponent implements OnInit {
  FeeForm: FormGroup;
  sTypeList: any;
  filteredsTypeList: any;
  stuStatusList: any;
  filteredstuStatusList: any;
  AdModeList: any;
  filteredAdModeList: any;
  SRList: any;
  filteredSR: any;
  totalAmount = 0;
  lvl: 0;
  shouldShowErrorMessage: boolean = false;
  inputTimeout: any;
  arrTest: any = [];
  tabldata: any;
  selectedoption: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  totalPayableAmount: number;
  totalPayAmount = 0;
  remainAmt = 0;
  Total = true;
  Message = false;
  StudentDocumentID;
  feeMode;
  tabldata2: any;
  due: number;
  submitButton = true;
  updateButton = false;
  feeApplyArray: FormArray;
  updateBtn: boolean;
  sum: number;
  errMsg: any;
  payModeList: any;
  filteredpayModeList: any;
  lastPaid: any;
  newPaid: any;
  ramt: number;
  userPermission: any;
  utp: string;
  feeCreate = true;
  zeroError = false;
  feeUpdate = true;
  onlinePayModeList: any;
  filteredOnlinePayModeList: any;
  offlinePayModeList: any;
  filteredOfflinePayModeList: any;
  FeeModeList: any;
  SessionNo: any;
  RAmt: any;
  showEqualMessage = false
  Currency: any;
  constructor(private fb: FormBuilder,
    public umsService: UmsService, public dialogRef1: MatDialogRef<FeeProcessComponent>,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  FeeTable: any;
  college = sessionStorage.getItem("college");
  course = sessionStorage.getItem("course");
  payOnline
  payOffline
  ngOnInit(): void {
    this.updateBtn = true;
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.totalAmount = 0;
    this.totalPayAmount = 0;
    this.remainAmt = 0;
    this.ramt = 0;
    this.due = 0;
    this.lvl = 0;
    this.Total = true;
    this.Message = false;
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Apply Admission Fee' && element.PCreate == false) {
          this.feeCreate = false;
        }
        if (element.PageName == 'Apply Admission Fee' && element.PUpdate == false) {
          this.feeUpdate = false;
        }
        // if(element.PageName == 'Faculty' && element.PDelete == false)
        // {
        //     this.FacultyDelete = false;  
        // }
      });
    }
    this.FeeForm = this.fb.group({
      // TemplateName: new FormControl('',[Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
      // StudentType: new FormControl('',[]),
      // StudentStatus: new FormControl(''),
      TotalPaidAmount: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      PayMode: new FormControl(''),
      // SocialReservation: new FormControl(''),
      feeHeadArray: new FormArray([]),
    });
    // this.fetchOnlinePayMode()
    // this.fetchOfflinePayMode()
    this.getFeeModeData();
    this.fetchAddmissionMode();
    this.prepopulation();
    this.fetchPayMode();
    this.getData()

  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
    }
    );
  }

  fetchPayMode() {
    const payload = {};
    payload['CdType'] = 'PM';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.payModeList = res.data;
        this.filteredpayModeList = this.payModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }


  getData() {
    this.spinner.show();
    const payload = {};
    payload['TemplateCode'] = this.data.TempCode;
    payload['FeeType'] = ''
    // this.disablePaid = true;
    this.umsService.getFeeTemplet(payload).subscribe((res) => {
      this.spinner.hide()
      let data = res.data[0];
      this.Currency = res.data[0].Currency
      if (res.status) {
        this.FeeTable = res.data;
      } else {
        // this.umsService.openSnackbar(res.message);
      }
    });
  }
  //   fetchStudentType() {
  //     const payload = {};
  //     payload['CdType'] = 'STYPE';
  //     this.umsService.getCodeType(payload).subscribe((res) => {
  //       if (res.status) {
  //         this.sTypeList = res.data;
  //         this.filteredsTypeList = this.sTypeList.slice();
  //       } else {
  //         //this.apimicroservice.openSnackbar(res.message);
  //       }
  //     });
  //   }

  //  fetchStudentStatus() {
  //     const payload = {};
  //     payload['CdType'] = 'STUST';
  //     this.umsService.getCodeType(payload).subscribe((res) => {
  //       if (res.status) {
  //         this.stuStatusList = res.data;
  //         this.filteredstuStatusList = this.stuStatusList.slice();
  //       } else {
  //         //this.apimicroservice.openSnackbar(res.message);
  //       }
  //     });
  //   }

  //   fetchSocialReservation() {
  //     const payload = {};
  //     payload['CdType'] = 'SR';
  //     this.umsService.getCodeType(payload).subscribe((res) => {
  //       if (res.status) {
  //         this.SRList = res.data;
  //         this.filteredSR = this.SRList.slice();
  //       } else {
  //         //this.apimicroservice.openSnackbar(res.message);
  //       }
  //     });
  //   }
  fetchAddmissionMode() {
    const payload = {};
    payload['CdType'] = 'AMODE';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.AdModeList = res.data;
        this.filteredAdModeList = this.AdModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  addNewRow() {
    const creds = this.FeeForm.controls.feeHeadArray as FormArray;
    creds.push(
      this.fb.group({
        FeeHead: new FormControl('', [Validators.required]),
        Head: new FormControl('',),
        FeePaid: new FormControl(0),
        FeeDueCal: new FormControl(0),
        FeeDue: new FormControl(0),
        FeeAmt: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      })
    );

  }

  prepopulation() {
    this.Total = true;
    this.Message = false;
    this.spinner.show();
    const payload = {};
    // payload['TemplateCode'] =  this.data;
    payload['FeeTemplateCode'] = this.data.TempCode;
    payload['StuId'] = this.data.StuId;
    payload['FeeHistory'] = 1;
    payload['SnNo'] = this.data.SessionId
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      let data = res.data[0];
      this.spinner.hide()
      if (res.status) {
        this.spinner.hide()
        this.updateButton = true;
        this.submitButton = false;
        this.tabldata2 = res.data;
        this.FeeForm = this.fb.group({
          TotalPaidAmount: new FormControl('', Validators.required),
          PayMode: new FormControl(data.PayMode),
          feeHeadArray: new FormArray([]),
        });
        this.tabldata2 = res.data;
        this.lastPaid = data.TotalPaidAmount
        this.tabldata2.forEach((element, i) => {
          const creds = this.FeeForm.controls.feeHeadArray as FormArray;
          creds.push(
            this.fb.group({
              FeeHead: new FormControl(element.FeeHead, [Validators.required]),
              HeadName: new FormControl(element.Head),
              FeePaid: new FormControl(0),
              FeeDue: new FormControl(element.FeeDue),
              FeeDueDummy: new FormControl(element.FeeDue),
              FeeAmt: new FormControl(element.FeeAmt, [Validators.required, Validators.pattern('^[0-9]*$')]),
            })
          );

          this.totalAmount = this.totalAmount + parseInt(element.FeeDue);
          this.remainAmt = this.totalAmount - this.lastPaid,
            this.RAmt = this.remainAmt;
          this.totalPayAmount = this.totalAmount - this.remainAmt;
          this.ramt = this.remainAmt;
          this.FeeForm.controls['TotalPaidAmount'].setValue('');
          if (this.totalAmount == 0) {
            this.FeeForm.controls['TotalPaidAmount'].setValue(0);
            this.updateBtn = false;
          } else {
            this.FeeForm.controls['TotalPaidAmount'].setValue('');
          }
          if (this.remainAmt == 0) {
            this.updateBtn = true;
            this.Total = false;
            this.Message = true;
            // this.payHistoryBtn = true;
          } else {
            this.updateBtn = false;
            this.Total = true;
            this.Message = false;
            // this.payHistoryBtn = false;
          }
        });
      } else {
        this.spinner.show();
        const payload = {};
        payload['TemplateCode'] = this.data.TempCode;
        payload['FeeType'] = ''
        this.submitButton = true;
        // this.disablePaid = true;
        this.umsService.getFeeTemplet(payload).subscribe((res) => {
          this.spinner.hide()
          let data = res.data[0];
          if (res.status) {
            this.tabldata = res.data;
            this.FeeForm = this.fb.group({
              TotalPaidAmount: new FormControl('', Validators.required),
              PayMode: new FormControl(data.PayMode),
              feeHeadArray: new FormArray([]),
            });
            this.FeeTable = res.data;
            this.FeeTable.forEach((element, i) => {

              const creds = this.FeeForm.controls.feeHeadArray as FormArray;
              creds.push(
                this.fb.group({
                  FeeHead: new FormControl(element.FeeHead, [Validators.required]),
                  HeadName: new FormControl(element.Head),
                  FeePaid: new FormControl(0),
                  FeeDue: new FormControl(element.FeeAmount),
                  FeeDueDummy: new FormControl(element.FeeAmount),
                  FeeAmt: new FormControl(element.FeeAmount, [Validators.required, Validators.pattern('^[0-9]*$')]),
                })
              );
              this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
              this.remainAmt = this.totalAmount;
              this.totalPayAmount = this.totalAmount - this.remainAmt;
              this.ramt = this.remainAmt;
              if (this.totalAmount == 0) {
                this.updateBtn = false;
                this.FeeForm.controls['TotalPaidAmount'].setValue(0);
              } else {
                // this.FeeForm.controls['TotalPaidAmount'].setValue('');
              }
            });


          } else {
            // this.umsService.openSnackbar(res.message);
          }
        });
      }
    });


  }


  getfeeHeadArrayControls() {
    return (this.FeeForm.get('feeHeadArray') as FormArray).controls;
  }

  close() {
    this.dialogRef1.close();
  }



  submitFeeTemplet() {
    this.updateBtn = true;
    this.spinner.show();
    this.submitpayload = this.FeeForm.value;
    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            FeeTemplateCode: new FormControl(this.data.TempCode), //add neww
            StuId: new FormControl(this.data.StuId),
            FeeHead: new FormControl(element.FeeHead),
            FeeType: new FormControl('AF'),
            FeeAmt: new FormControl(element.FeeAmt),
            FeePaid: new FormControl(element.FeePaid),
            FeeDueCal: new FormControl(element.FeeDue),
            FeeDue: new FormControl(element.FeeDue),
            FeePaymentMethod: new FormControl(this.data.Mode),
            TotalPaidAmount: new FormControl(this.totalAmount),
            PayMode: new FormControl(this.submitpayload.PayMode),
            SnNo: new FormControl(this.data.SessionId),
            CreatedBy: new FormControl(parseInt(sessionStorage.getItem('userId'))),
            TotalFeeAmount: new FormControl(this.totalAmount)
          })
        )
        this.umsService.addFeeTemplet1(arr1[0].value).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
            this.updateBtn = false;
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            this.updateBtn = false;
          }
          if (res.status == true) {
            iserror = false
            this.errMsg = res.message;
            this.updateBtn = false;
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {

        if (this.totalAmount == 0) {
          const randomFiveDigitNumber = Math.floor(10000 + Math.random() * 90000);
          let payload = {};
          payload['payment_source'] = 'Pay-0',
            payload['easepayid'] = randomFiveDigitNumber,
            payload['card_type'] = '-',
            payload['mode'] = '-',
            payload['email'] = '',
            payload['phone'] = '',
            payload['key'] = '',
            payload['txnid'] = '',
            payload['status'] = 'Success',
            payload['amount'] = this.totalAmount,
            payload['StuId'] = this.data.StuId,
            payload['FeeTemplateCode'] = this.data.TempCode,
            payload['FeeType'] = 'AF',
            payload['SnNo'] = this.data.SessionId,
            this.umsService.payZeroFee(payload).subscribe((res) => {
              if (res.status) {
                this.saveApplicationDetails(this.data.StuId, this.data.SessionId)
                this.spinner.hide()
                let data = {}
                 data['message'] =  "Waved Off",
                 data['title'] = 'Information'
                 data['icon'] = 'fas fa-check'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                this.ngOnInit()
              }
              else {
                this.spinner.hide()
                let data = {}
                data['message'] = res.message,
                data['title'] = 'Alert'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

              }
            });
        }
        else {
          this.saveApplicationDetails(this.data.StuId, this.data.SessionId)
          const paymentDetails = {
            "payment_source": '',
            "easepayid": "",
            "card_type": "",
            "mode": "",
            "email": " ",
            "phone": "",
            "key": "",
            "txnid": "",
            "status": "",
            "amount": this.totalAmount,
            "StuId": this.data.StuId,
            "FeeTemplateCode": this.data.TempCode,
            "FeeType": "AF",
            "SnNo": this.data.SessionId,
          }
          this.umsService.offlinePayResponce(paymentDetails).subscribe((response) => {
            if (response.status) {
              this.updateBtn = false;
              let data = {}
              data['message'] = "Submitted Successfully"
              data['title'] = 'Information'
              data['icon'] = 'fas fa-check'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              this.dialogRef.afterClosed().subscribe((result) => {
                this.ngOnInit();
              });
            }

          });
        }

      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    });

  }


  saveApplicationDetails(StuId, SnNo) {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    this.spinner.show()
    let payload = {};
    payload['StuId'] = StuId
    payload['SessionId'] = SnNo
    payload['CgCode'] = sessionStorage.getItem("college");
    payload['CoCode'] = sessionStorage.getItem("course");
    payload['ApplicationName'] = 'Admission Fees'
    payload['ApplicationSubDate'] = formattedDate;
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      } else {
        this.spinner.hide()
      }
    })
  }

  amountCheck(index) {
    let amountValue = (<FormArray>this.FeeForm.get("feeHeadArray")).at(index).get('FeeDue').value;

    this.FeeTable.forEach((element, i) => {

      if (element.FeeAmount < amountValue) {
        let data = {}
        data['message'] = "Payable Amount Should be Less than Or Equal to Fee Amount"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    })
  }


  onInputChange1(event: any, i) {
    clearTimeout(this.inputTimeout);
    this.inputTimeout = setTimeout(() => {
      this.dueAmt(event, i)
      this.getAmount(event, i)
    }, 500);
  }


  onInputChange(val) {
    const tempData = val.target.value;
    this.updateBtn = true;
    // return
    // if (tempData.charAt(0) === '0') {
    //   this.zeroError = true;
    // }
    // else if (tempData.charAt(0) !== '0') {
    //   this.zeroError = false;
    // }
    if (tempData == '') {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.ramt;
      this.showEqualMessage = false;
    }
    if (this.totalAmount == tempData && this.submitButton == true && this.lastPaid == undefined) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.totalAmount - tempData;
    }
    if (this.totalAmount > tempData || tempData > this.totalAmount) {
      this.showEqualMessage = true;
      // this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      // this.remainAmt = this.ramt;
    }
    else if (tempData == '') {
      this.showEqualMessage = false;
      this.updateBtn = true
    }
    else if (tempData == this.totalAmount) {
      this.showEqualMessage = false;
      this.updateBtn = false
    }
    if (this.ramt < tempData || tempData > this.totalAmount) {

      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.ramt;
    }
    else if (tempData == 0) {
      this.shouldShowErrorMessage = false;
      // this.updateBtn = true;
      this.newPaid = 0;
    }
    else {
      if (this.lastPaid == undefined && this.submitButton == true) {
        this.shouldShowErrorMessage = false;
        // this.updateBtn = false;
        this.remainAmt = this.totalAmount - tempData;
        if (this.remainAmt == 0) {
          this.updateBtn = false
          // this.payHistoryBtn = true;
        } else {
          this.updateBtn = true
          // this.payHistoryBtn = false;
        }
      }

      this.shouldShowErrorMessage = false;
      // this.updateBtn = false;
      this.remainAmt = this.ramt - tempData;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData);
      // this.newPaid = parseInt(tempData);
      if (this.remainAmt == 0) {
        this.updateBtn = false
        // this.payHistoryBtn = true;
      } else {
        this.updateBtn = true
        // this.payHistoryBtn = false;
      }
    }
  }

  // isGreaterThanInput(): boolean {
  //   const tempData= this.FeeForm.value;
  //   const Data= this.FeeForm.controls.feeHeadArray.value;
  //   return +tempData.TotalPaidAmount > this.remainAmt;
  // }

  dueAmt(event, i) {
    let arrayData = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i);
    let amountValue = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i).get('FeePaid').value;
    amountValue = parseInt(amountValue);
    const tempData = this.FeeForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    // this.remainAmt = 0
    if (tempData[i]['FeePaid'] == '') {
      this.due = tempData[i]['FeeDueCal'];
    }
    else {
      this.due = parseInt(tempData[i]['FeeDueCal']) - parseInt(tempData[i]['FeePaid']);
    }

    this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
    this.feeApplyArray.at(i).get('FeeDue').setValue(this.due);

  }



  getAmount(event: any, i) {
    const tempData = this.FeeForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    let sumFeeDue = 0;
    tempData.forEach(element => {
      sumFeeDue += element.FeeDue;
    })
    this.remainAmt = sumFeeDue;
    this.totalPayAmount = this.totalAmount - this.remainAmt;
  }

  updateFeeTemplet() {
    this.FeeForm.controls['TotalPaidAmount'].setValue(this.newPaid);
    this.spinner.show();
    this.submitpayload = this.FeeForm.value;

    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];

        arr1.push(
          this.fb.group({
            FeeTemplateCode: new FormControl(this.data.TempCode), //add neww
            StuId: new FormControl(this.data.StuId),
            FeeHead: new FormControl(element.FeeHead),
            FeeAmt: new FormControl(element.FeeAmt),
            FeeType: new FormControl('AF'),
            FeePaid: new FormControl(element.FeePaid),
            FeeDueCal: new FormControl(element.FeeDue),
            FeeDue: new FormControl(element.FeeDue),
            FeePaymentMethod: new FormControl(this.data.Mode),
            TotalPaidAmount: new FormControl(this.totalAmount),
            PayMode: new FormControl(this.submitpayload.PayMode),
            CreatedBy: new FormControl(parseInt(sessionStorage.getItem('userId'))),
            TotalFeeAmount: new FormControl(this.totalAmount)
          })
        )
        this.umsService.updateFeeTemplet1(arr1[0].value).subscribe(res => {

          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            const paymentDetails = {
              "amount": arr1[0].value.TotalPaidAmount,
              "firstname": arr1[0].value.FeeHead,
              "email": "jeeevishnu@gmail.com",
              "phone": "8296270993"
            }
            this.umsService.paymentgateway(paymentDetails).subscribe((response) => {
              // window.location.href = response.redirectUrl;

              window.open(response.redirectUrl, '_blank');
            });
          }
        },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          }
        );
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Update Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.dialogRef1.close();
          this.ngOnInit();
        });
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    });

  }


  openHistoryPopup() {
    // localStorage.clear();
    // sessionStorage.setItem('TemplateCode',item.TemplateCode);
    let data = {};
    data['Temp'] = this.data.TempCode;
    data['StuId'] = this.data.StuId;
    data['SnNo'] = this.data.SessionId
    const dialogRef4 = this.dialog.open(PaymentHistoryComponent,
      {
        disableClose: true,
        width: "700px",
        height: "auto",
        data
      });
    dialogRef4.afterClosed().subscribe((result) => {

    });
  }


  fetchOnlinePayMode() {

    const payload = {};
    payload['CdType'] = 'ONLN';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.onlinePayModeList = res.data;
        this.filteredOnlinePayModeList = this.onlinePayModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchOfflinePayMode() {

    const payload = {};
    payload['CdType'] = 'OFFLN';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.offlinePayModeList = res.data;
        this.filteredOfflinePayModeList = this.offlinePayModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }


  getFeeModeData() {
    this.spinner.show();
    const payload = {};
    payload["Session"] = this.SessionNo;
    payload['College'] = this.college;
    this.umsService.fetchCheckFeeMode(payload).subscribe(res => {
      this.FeeModeList = res.data;

      this.spinner.hide();
      if (res.data[0].FeeMode == 'ONLIN') {
        this.fetchOnlinePayMode();
        this.payOnline = true;
        this.payOffline = false;
      }
      else if (res.data[0].FeeMode == 'OFFLI') {
        this.fetchOfflinePayMode()
        this.payOffline = true;
        this.payOnline = false;
      }
    });
  }

}
